import { METHODS, requestV3 } from '../axiosInstances';

export default {
  get: (params = {}) => requestV3(METHODS.GET, `/management/legacy/`, { params }),
};
